import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${(props) => (props.color ? props.color : '#ccc')};

    ${({ marginTop }) => marginTop && `margin-top: ${marginTop}`}
`;
